import { Notification } from '@thanx/uikit/notification'
import { Text } from '@thanx/uikit/text'
import ExclamationTriangleO from 'components/Icons/ExclamationTriangleO'
import palette from 'constants/palette'
import React from 'react'

type Props = {
  title: string
  text: string
  showIcon?: boolean
}

const WarningBanner = ({ title, text, showIcon = false }: Props) => {
  return (
    <Notification kind="warning" size="full">
      {/* role="status" announces the warning when it appears dynamically
          (e.g. after the merchant switches via MerchantPicker). */}
      <div className="d-flex p-xs" role="status">
        {showIcon && (
          // Decorative icon — the title/text already convey the warning, so
          // hide it from screen readers (a11y checklist).
          <div className="mr-xs mt-xxs" aria-hidden="true">
            <ExclamationTriangleO
              pathColor={palette.eggYolk}
              testId="warning-banner-icon"
            />
          </div>
        )}
        <div>
          <Text.BodyText4 bold color="grey90" tag="p" className="mb-xs">
            {title}
          </Text.BodyText4>
          <Text.BodyText4 color="grey70" tag="p" className="mb-0">
            {text}
          </Text.BodyText4>
        </div>
      </div>
    </Notification>
  )
}

export default WarningBanner
